<div class="report-sent">
  <mat-icon class="report-sent__icon">mark_email_read</mat-icon>
  <div class="report-sent__body">
    <div class="report-sent__title">Your report is on its way</div>
    <div class="report-sent__text">
      We're generating it now and will email a download link in the next few
      minutes<ng-container *ngIf="data.email">
        to <strong>{{ data.email }}</strong></ng-container
      >.
    </div>
  </div>
  <button
    type="button"
    class="report-sent__close"
    aria-label="Dismiss"
    (click)="snackBarRef.dismiss()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
